import React, { useEffect, useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import "../navigation/navigation.css";
import { ReactComponent as Logo } from "../../assets/svgs/logo.svg";
import storage from "../../utils/storage";
// import { useDispatch, useSelector } from "react-redux";
// Import icons
import { FaHome, FaCalendarAlt, FaTicketAlt, FaEnvelope, FaUserCog, FaSignOutAlt, FaPlus, FaFutbol, FaClock, FaList, FaComments, FaUser, FaChartLine, FaFileAlt, FaChartBar } from 'react-icons/fa';
import { TbLayoutSidebarRightExpand, TbLayoutSidebarLeftExpand } from "react-icons/tb";

// Helper function to determine container class
export const getContainerClass = (pathname) => {
  return `home-container${pathname === "/home" ? "" : " ucomp"}`;
};

const Navigation = ({ isSidebarOpen = true, onSidebarToggle }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  // Check authentication status
  useEffect(() => {
    const checkAuth = async () => {
      try {
        const token = await storage.getItem('token');
        setIsAuthenticated(!!token);
      } catch (error) {
        console.error('Error checking authentication:', error);
        setIsAuthenticated(false);
      } finally {
        setIsLoading(false);
      }
    };

    checkAuth();
  }, []);

  const handleSidebarToggle = () => {
    if (onSidebarToggle) onSidebarToggle();
  };



  const handleLogout = async () => {
    try {
      await storage.clear(); // This will clear both cookies and localStorage
      navigate("/");
    } catch (error) {
      console.error('Error during logout:', error);
      // Still navigate to home even if clear fails
      navigate("/");
    }
  };

  const handleNavigation = (path) => (e) => {
    e.preventDefault();
    navigate(path);
  };

  const isActive = (path) => {
    return location.pathname === path;
  };

  return (
    <>
      {isAuthenticated && !isLoading && (
        <div className={`sidebar ${isSidebarOpen ? 'open' : 'closed'}`}>
          <div className="sidebar-header">
            <div className="logo-container">
              {isSidebarOpen ? (
                <>
                  <Link to="/home" onClick={handleNavigation("/home")}>
                    <Logo className="logo" />
                  </Link>
                  <div style={{ color: '#fff' }} className="portal-title">Facility Management Portal</div>
                </>
              ) : null}
            </div>
            <button className="toggle-btn" onClick={handleSidebarToggle}>
              {isSidebarOpen ? <TbLayoutSidebarRightExpand /> : < TbLayoutSidebarLeftExpand />}
            </button>
          </div>



          <nav className="sidebar-nav">
            <Link
              to="/home"
              className={`nav-item ${isActive("/home") ? "active" : ""}`}
              onClick={handleNavigation("/home")}
            >
              <FaHome className="nav-icon" />
              {isSidebarOpen && <span className="nav-text">Home</span>}
            </Link>

            <Link
              to="/Dashboard"
              className={`nav-item ${isActive("/Dashboard") ? "active" : ""}`}
              onClick={handleNavigation("/Dashboard")}
            >
              <FaChartLine className="nav-icon" />
              {isSidebarOpen && <span className="nav-text">Analytics Dashboard</span>}
            </Link>

            <Link
              to="/analytics"
              className={`nav-item ${isActive("/analytics") ? "active" : ""}`}
              onClick={handleNavigation("/analytics")}
            >
              <FaChartBar className="nav-icon" />
              {isSidebarOpen && <span className="nav-text">Reports</span>}
            </Link>

            {isSidebarOpen && <div className="section-title">Facilities</div>}
            <Link
              to="/Facilities"
              className={`nav-item ${isActive("/Facilities") ? "active" : ""}`}
              onClick={handleNavigation("/Facilities")}
            >
              <FaList className="nav-icon" />
              {isSidebarOpen && <span className="nav-text">Facility and Slots</span>}
            </Link>

            <Link
              to="/AddFacility"
              className={`nav-item ${isActive("/AddFacility") ? "active" : ""}`}
              onClick={handleNavigation("/AddFacility")}
            >
              <FaPlus className="nav-icon" />
              {isSidebarOpen && <span className="nav-text">Add Facility</span>}
            </Link>
            <Link
              to="/Pitch"
              className={`nav-item ${isActive("/Pitch") ? "active" : ""}`}
              onClick={handleNavigation("/Pitch")}
            >
              <FaFutbol className="nav-icon" />
              {isSidebarOpen && <span className="nav-text">Pitch/Court</span>}
            </Link>
            <Link
              to="/createslots"
              className={`nav-item ${isActive("/createslots") ? "active" : ""}`}
              onClick={handleNavigation("/createslots")}
            >
              <FaClock className="nav-icon" />
              {isSidebarOpen && <span className="nav-text">Create Slots</span>}
            </Link>

            <Link
              to="/slots"
              className={`nav-item ${isActive("/slots") ? "active" : ""}`}
              onClick={handleNavigation("/slots")}
            >
              <FaTicketAlt className="nav-icon" />
              {isSidebarOpen && <span className="nav-text">Slots</span>}
            </Link>



            {isSidebarOpen && <div className="section-title">Booking & Schedule</div>}
            <Link
              to="/Bookings"
              className={`nav-item ${isActive("/Bookings") ? "active" : ""}`}
              onClick={handleNavigation("/Bookings")}
            >
              <FaCalendarAlt className="nav-icon" />
              {isSidebarOpen && <span className="nav-text">Bookings</span>}
            </Link>
            <Link
              to="/Schedule"
              className={`nav-item ${isActive("/Schedule") ? "active" : ""}`}
              onClick={handleNavigation("/Schedule")}
            >
              <FaClock className="nav-icon" />
              {isSidebarOpen && <span className="nav-text">Schedule</span>}
            </Link>

            <Link
              to="/Contactus"
              className={`nav-item ${isActive("/Contactus") ? "active" : ""}`}
              onClick={handleNavigation("/Contactus")}
            >
              <FaEnvelope className="nav-icon" />
              {isSidebarOpen && <span className="nav-text">Contact Us</span>}
            </Link>

            <Link
              to="/messages"
              className={`nav-item ${isActive("/messages") ? "active" : ""}`}
              onClick={handleNavigation("/messages")}
            >
              <FaComments className="nav-icon" />
              {isSidebarOpen && <span className="nav-text">Messages</span>}
            </Link>

            {isSidebarOpen && <div className="section-title">Account</div>}
            <Link
              to="/Profile"
              className={`nav-item ${isActive("/Profile") ? "active" : ""}`}
              onClick={handleNavigation("/Profile")}
            >
              <FaUser className="nav-icon" />
              {isSidebarOpen && <span className="nav-text">Profile</span>}
            </Link>
            <Link
              to="/AccountSettings"
              className={`nav-item ${isActive("/AccountSettings") ? "active" : ""}`}
              onClick={handleNavigation("/AccountSettings")}
            >
              <FaUserCog className="nav-icon" />
              {isSidebarOpen && <span className="nav-text">Account Settings</span>}
            </Link>
            <button onClick={handleLogout} className="nav-item logout-btn">
              <FaSignOutAlt className="nav-icon" />
              {isSidebarOpen && <span className="nav-text">Logout</span>}
            </button>
          </nav>
        </div>
      )}
    </>
  );
};

export default Navigation;
